import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SupplierMigration from "./components/supplier";
import CustomerMigration from "./components/customer";
import ProductMigration from "./components/product";
import ExpensesMigration from "./components/expenses";
import OtherIncome from "./components/other_income";
import Accounts from "./components/accounts";

import axios from "axios";
import BASE_URL from "../../assets/global/url";
import Select from "react-select";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import SalesMigration from "./components/SalesMigration";
import PayableMigration from "./components/PayableMigration";
import FixedAssetMigration from "./components/FixedAssetMigration";
import IssuedCheckMigration from "./components/issued_check";
import ReceivableCheckMigration from "./components/ReceivableCheckMigration";
import RetainedEarningsMigration from "./components/RetainedEarningsMigration";
const Migration_Page = ({ authrztn }) => {
  const userLoggedID = useDecodeToken();

  const [productOptions, setProductOptions] = useState([]);
  const [product, setProduct] = useState([]);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [lastDate, setLastDate] = useState("");

  const fetchProduct = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/product/getProductData`);
      const options = res.data.map((item) => ({
        value: item.product_id,
        label: item.product_name,
      }));
      setProductOptions(options);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  const months = [
    { value: 0, name: "January" },
    { value: 1, name: "February" },
    { value: 2, name: "March" },
    { value: 3, name: "April" },
    { value: 4, name: "May" },
    { value: 5, name: "June" },
    { value: 6, name: "July" },
    { value: 7, name: "August" },
    { value: 8, name: "September" },
    { value: 9, name: "October" },
    { value: 10, name: "November" },
    { value: 11, name: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 20 }, (_, i) => currentYear - 10 + i); // 10 years back and forward

  useEffect(() => {
    if (month !== "" && year !== "") {
      const date = new Date(year, parseInt(month) + 1, 0); // Last day of month
      const formatted = date.toLocaleDateString("en-CA"); // Outputs YYYY-MM-DD in local time
      setLastDate(formatted);
    }
  }, [month, year]);

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="container-fluid ">
        {" "}
        <div className="w-100 p-2 d-flex flex-row justify-content-between">
          <div className="d-flex flex-column title-custom">
            <span className="fs-3">Migration Page</span>
          </div>

          <div className="d-flex gap-2 align-items-center">
            <div className="d-flex flex-column">
              <label className="form-label mb-1">Month to Migrate</label>
              <select
                className="form-select"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {months.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column">
              <label className="form-label mb-1">Year to Migrate</label>
              <select
                className="form-select"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                <option value="">Select Year</option>
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
            {lastDate && (
              <div className="d-flex flex-column">
                <label className="form-label mb-1 invisible">Last Date</label>
                <span className="badge bg-primary align-self-start">
                  Last Date: {lastDate}
                </span>
                <small className="text-muted">
                  This will be used as the base date of the migration.
                </small>
              </div>
            )}

            {userLoggedID === "11111111-1111-1111-1111-111111111111" && (
              <Link
                to="/technical-tools"
                className="btn btn-primary align-self-end text-nowrap"
              >
                <i className="fa-solid fa-screwdriver-wrench me-2"></i>
                Technical Tools
              </Link>
            )}
          </div>
        </div>
        <SupplierMigration lastDate={lastDate} />
        <div className="border m-3"></div>
        <CustomerMigration lastDate={lastDate} />
        <div className="border m-3"></div>
        <ExpensesMigration lastDate={lastDate} />
        <div className="border m-3"></div>
        <ProductMigration lastDate={lastDate} />
        <div className="border m-3"></div>
        <OtherIncome lastDate={lastDate} />
        <div className="border m-3"></div>
        <Accounts lastDate={lastDate} />
        <div className="border m-3" />
        <SalesMigration lastDate={lastDate} />
        <div className="border m-3" />
        <PayableMigration lastDate={lastDate} />
        <div className="border m-3" />
        <FixedAssetMigration lastDate={lastDate} />
        <div className="border m-3" />
        <IssuedCheckMigration lastDate={lastDate} />
        <div className="border m-3" />
        <ReceivableCheckMigration lastDate={lastDate} />
        <div className="border m-3" />
        <RetainedEarningsMigration />
      </div>
    </div>
  );
};

export default Migration_Page;
